import React from 'react';
import { Col } from 'react-flexbox-grid'

class Item extends React.Component {
    render() {
        const { classes } = this.props;
        return (   
                <div {...this.props}>
                    <div className='containerPicking'>
                        <div onClick={this.props.onClick} className='containerItemSubrubroPicking sortable-list'>
                            <div className='imgNombre'>
                                <img src={this.props.item.imagen ? this.props.item.imagen : require('./../../images/default_subrubro.png')}  onDragStart={(e)=>{e.preventDefault();}} alt=""/>
                                <div>
                                    <div className="nombreSubrubro">{this.props.item.nombre}</div> {/*Nombre SubRubro */}
                                    <div className="nombreRubro">{this.props.item.nombreRubro}</div> {/*Nombre Rubro */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Item